import { Select } from 'antd';
import { classNames } from 'src/utilities';
import { Field } from 'formik';
import { Text } from '.';

export const SingleSelect = ({
  disabled,
  placeholder,
  options,
  onChange,
  popupClassName,
  className,
  name,
  label,
  value,
  dropdownMode,
}) => {
  return (
    <Field name={name}>
      {({ form: { setFieldTouched } }) => {
        return (
          <div className="w-full custom-select-component">
            {label ? (
              <Text type={'label'} htmlFor={name}>
                {label}
              </Text>
            ) : null}
            <Select
              bordered={false}
              id={name}
              showSearch={true}
              optionFilterProp="label"
              disabled={disabled}
              placeholder={placeholder}
              className={classNames(
                'font-sans w-full',
                className ? className : 'single-select'
              )}
              mode={dropdownMode}
              popupClassName={classNames(
                'single-select__dropdown',
                popupClassName ? popupClassName : ''
              )}
              options={options}
              dropdownStyle={{
                zIndex: 999999999,
              }}
              onChange={onChange ? onChange : () => null}
              value={value || null}
              onBlur={() => {
                setFieldTouched(name, true);
              }}
            />
            {/* {meta?.touched && meta?.error ? (
                            <Text type={"error"} className={"error mt-2"}>
                                {meta?.error}
                            </Text>
                        ) : null} */}
          </div>
        );
      }}
    </Field>
  );
};
